import React from 'react';
import Header from '../header/header';
import Footer from '../footer/footer';
import './Accreditations.css';
import GAQM from '../../../assets/logos/GAQM_ATC_Logo.png';
import iqn1 from '../../../assets/logos/minibba.png';
import iqn2 from '../../../assets/logos/iqn2.png';
import iqnletter from '../../../assets/logos/iqnletter-1.png';
import iqnletter2 from '../../../assets/logos/iqnletter2.png';
import gaqmletter from '../../../assets/logos/Accreditation_Letter_Meantoir-1.png';
import logo3 from '../../../assets/logos/IRS-EA-Logo.png';
import logo4 from '../../../assets/logos/New HOCK Logo-2.png';

function Accreditations() {
    return (
        <div className="acc-wrapper">
            <Header />
            <div className="acc-container">
                <h1 className="homepage-heading">Our Accreditations & Affiliations</h1>
                {/* HOCK */}
                <div className="acc-card">
                    <div className="acc-content">
                        <h2 className="acc-heading">HOCK International</h2>
                        <div className="acc-logo-wrapper">

                            <img src={logo4} alt="HOCK Logo 2" className="acc-logo" />
                            <img src={logo3} alt="HOCK Logo 1" className="acc-logo" style={{ width: "220px" }} />
                        </div>
                        <div className="acc-links">
                            <a href="https://www.hockinternational.com/" target="_blank" rel="noopener noreferrer">Visit Website</a>
                        </div>
                        <p>HOCK International is a family-owned company specializing in providing comprehensive
                            self-study materials and personalized support for accounting professionals pursuing
                            certifications such as the Enrolled Agent (EA), Certified Management Accountant (CMA),
                            Certified Internal Auditor (CIA), and Chartered Financial Analyst (CFA). Founded in 2003
                            by Brian Hock, the company is headquartered in Columbus, Ohio, USA. HOCK International distinguishes
                            itself by offering guarantees including up-to-date materials, ongoing support until exam success,
                            lifetime access to resources, and competitive pricing. </p>
                    </div>
                </div>
                {/* GAQM */}
                <div className="acc-card">
                    <div className="acc-content">
                        <h2 className="acc-heading">GAQM® (Global Association for Quality Management®)</h2>
                        <div className="acc-logo-wrapper">
                            <img src={GAQM} alt="GAQM Logo" className="acc-logo" />
                        </div>
                        <div className="acc-links">
                            <a href={gaqmletter} target="_blank" rel="noopener noreferrer">Accreditation Letter</a>
                        </div>
                        <p className="acc-note"><i>Global Association for Quality Management® (GAQM)® has gained Membership
                            status from the Accreditation Service for International Schools, Colleges and Universities (ASIC).
                            ASIC is recognized by UKVI in UK, is a member of the CHEA International Quality Group (CIQG) in USA
                            and is listed in their International Directory, is a member of the BQF (British Quality Foundation),
                            are affiliates of ENQA (European Network for Quality Assurance) and
                            are institutional members of EDEN (European Distance and E-Learning Network)</i></p>
                        <p className="acc-note"><i><b>Global Association for Quality Management (GAQM)® is also a British Quality
                            Foundation (BQF) Bronze Member.</b></i></p>
                        <p>The main aim of GAQM® is to offer Quality and Internationally Accredited Training and Certification in
                            the field of Finance, Management Science and Information Technology. We impart quality education and
                            training in all the certifications which is at par with the Global Standards. Unlike other certification
                            bodies we don't just ask the candidates to pass the exam, our main objective is to educate via E-Courses
                            and Virtual Class Room sessions, followed by an exam which the candidate needs to take through
                            ProctorU via Online Proctoring Mode which follows a stringent process of examination.</p>
                        <p>The Credentials/Certifications which the GAQM® offers have increased acceptability around the
                            world by the corporate sector. The Certification programs offered by the GAQM® are accepted and
                            recognized by employers worldwide. As an International Institute, the Certification offered by the
                            GAQM® is at par with the global standards. Moreover, all of our courseware's are approved and
                            authorized by the International Group of Experts and Professionals.</p>
                        <p className="acc-note">The GAQM® is an Internationally Recognized Organization maintaining
                            benchmark in Education and Certification it offers, GAQM® has certified
                            over 80,000 individuals across the globe.</p>
                        <h3>Certification: </h3>
                        <p>GAQM provides successful candidates with a hardcopy certificate, which is
                            enhanced with several security features to prevent copying and ensure authenticity.
                            These features include a vertical hologram strip,
                            heat sensitivity, as well as micro text and UV invisible ink.</p>
                    </div>
                </div>

                {/* IQN */}
                <div className="acc-card">
                    <div className="acc-content">
                        <h2 className="acc-heading">IQN® (International Qualifications Network®)</h2>
                        <div className="acc-logo-wrapper">

                            <img src={iqn2} alt="IQN Logo" className="acc-logo" />
                            <img src={iqn1} alt="IQN Logo" className="acc-logo" />
                        </div>
                        <div className="acc-links">
                            <a href={iqnletter2} target="_blank" rel="noopener noreferrer">Accreditation Letter  </a>
                            <a href={iqnletter} target="_blank" rel="noopener noreferrer">       Accreditation Letter</a>
                        </div>
                        <p>A leading international certification and examination body, IQN® (International Qualifications Network®)
                            offers qualifications designed to meet today's professional needs through design, assessment, and
                            awarding. As a leading provider of high-quality certification programs, IQN® enables individuals
                            to excel in their careers while balancing their other responsibilities.</p>
                        <p>IQN® qualifications that are not only approved under the UK's national qualifications
                            framework but
                            also recognized globally by esteemed employers and organizations worldwide. </p>
                        <p>IQN® qualifications are benchmarked against the European Qualifications Framework (EQF).
                            In collaboration with esteemed global learning brands like the University of the West of Scotland,
                            bring you qualifications that are backed by industry expertise and academic rigor. </p>
                        <p>Upon successful completion of your qualification, IQN® issue digital badges and verifiable digital
                            certificates through Credly, leveraging cutting-edge block chain technology. This ensures that your
                            achievements are securely and transparently recorded, allowing you to showcase your
                            skills and credentials with confidence in today's competitive job market.</p>
                        <p className="acc-note">We have certified 15,000+ students from 65+ countries!</p>
                        <p>Join the ranks of over 15,000 IQN® certified students from 65+ countries who have trusted IQN to advance their career and enhance their professional skills.</p>
                        <p className="acc-note">UWS (University of West of Scotland)</p>
                        <p>University of the West of Scotland aims to have a transformational influence on the economic,
                            social and cultural development of the West of Scotland and beyond. UWS is officially recognised by
                            Times Higher Education in top 600 of universities worldwide (2020 World University Rankings) and in
                            top 130 of universities worldwide under 50 years old (2021 Young University Rankings). The Times/The
                            Sunday Times Good University Guide 2019 ranked UWS as a top 100 UK university and as the highest ranked
                            post-1992
                            university in Scotland for both teaching quality and student experience.</p>
                        <p className="acc-note">SCQF (Scottish Credit and Qualifications Framework)</p>
                        <p>Certified Finance Specialist qualification is recognized on the Scottish Credit
                            and Qualifications Framework (SCQF). The SCQF is one of the national qualifications
                            frameworks in the UK and is managed by the Scottish Credit and Qualifications Framework
                            (SCQF) Partnership. The SCQF Partnership includes members from the Quality Assurance Agency
                            for Higher Education (QAA), College Development Network (CDN), the Scottish Qualifications Authority
                            (SQA) and Universities Scotland. It ensures that the Certified Finance Specialist qualification is
                            recognized not only in
                            Scotland, the United Kingdom, or Europe, but worldwide as well. </p>
                        <h3>Level & Credit</h3>
                        <p>CFS qualification has received SCQF credit points through the credit rating process,
                            which show how much learning has been achieved, and a
                            SCQF level which shows how demanding the learning is.</p>
                        <h3>Criteria</h3>
                        <p>CFS qualification is recognised on the SCQF by meeting criteria of learning outcomes, a minimum 10
                            notional learning hours, formal assessment, quality assurance etc.</p>
                        <h3>SCQF Level 7 characteristics of CFS qualification</h3>
                        <h5>Knowledge & Understanding</h5>
                        <p>An overall appreciation of body of knowledge. An awareness of the dynamic nature of knowledge and understanding.</p>
                        <h5>Applied Knowledge & Skills</h5>
                        <p>Apply knowledge, skills and understanding in using basic and routine professional skills, techniques and practices.</p>
                        <h5>Generic Cognitive Skills</h5>
                        <p>Present and evaluate arguments, information and ideas and use a range of approaches to address defined issues.</p>
                        <p className="acc-note">EQF (European Qualifications Framework)</p>
                        <p>Qualifications recognised under SCQF are aligned with European Qualifications Framework (EQF).
                            The EQF was formally adopted by the European Parliament and the European Council in 2008.
                            CFS certification is benchmarked as Level 5 qualifications in the EQF.</p>
                        <h3>EQF Level 5 characteristics of CFS qualification</h3>
                        <table className="accreditation-table">
                            <thead>
                                <tr>
                                    <th>Category</th>
                                    <th>Description</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Knowledge</td>
                                    <td>Comprehensive, specialised, factual and theoretical knowledge within a field of work or study and an awareness of the boundaries of that knowledge.</td>
                                </tr>
                                <tr>
                                    <td>Skills</td>
                                    <td>A comprehensive range of cognitive and practical skills required to develop creative solutions to abstract problems.</td>
                                </tr>
                                <tr>
                                    <td>Responsibility & Autonomy</td>
                                    <td>Exercise management and supervision in contexts of work or study activities where there is unpredictable change; review and develop performance of self and others.</td>
                                </tr>
                            </tbody>
                        </table>

                    </div>
                </div>


            </div>
            <Footer />
        </div>
    );
}

export default Accreditations;
